import { render, staticRenderFns } from "./InsertCustomForm.vue?vue&type=template&id=032f67dc&"
import script from "./InsertCustomForm.vue?vue&type=script&lang=js&"
export * from "./InsertCustomForm.vue?vue&type=script&lang=js&"
import style0 from "./InsertCustomForm.vue?vue&type=style&index=0&id=032f67dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports